import { ListaPrecoTabela } from './../../../../../shared/interfaces/lista-preco-tabela';
import { Parameters } from './../../../../../shared/interfaces/parameters';
import { ListaPreco } from 'app/shared/interfaces/lista-preco';
import { Preco } from 'app/shared/interfaces/preco';
import { CopiaPrecoItem } from 'app/shared/interfaces/copia-preco-item';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ListaPrecoService } from 'app/shared/services/lista-preco.service';
import { ListaPrecoTabelaService } from 'app/shared/services/lista-preco-tabela.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-produto-preco-edit-popup',
  templateUrl: './produto-preco-edit-popup.component.html',
  styleUrls: ['./produto-preco-edit-popup.component.scss'],
  providers: [

    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProdutoPrecoEditPopupComponent implements OnInit {

  produtoPrecoForm: FormGroup;
  preco: Preco;
  precos: Preco[];
  layoutConf: any;
  startDate = new Date();
  /** Requisição em curso: trava o botão salvar. */
  salvando = false;
  /** Evita laço entre os cálculos de % desconto e preço promocional. */
  private calculando = false;

   /**
  * Ao Teclar Esc
  */
    // @HostListener('window:keyup.esc') onKeyUp() {
    //   if (this.dialog.openDialogs.length > 0 ) {
    //     console.log('@HostListener(window:keyup.esc) onKeyUp()');
    //     this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //       .subscribe(res => {
    //         if (res) {

    //           this.dialogRef.close();
    //         }
    //       });
    //   }
    // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoPrecoEditPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private listaPrecoService: ListaPrecoService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.preco = this.data.payload;
    this.buildProdutoPrecoForm(this.preco);
    this.ligarCalculoPromocional();
  }

  /**
   * % desconto e preço promocional andam juntos: digitar um calcula o outro a partir do preço,
   * como na manutenção de preço do desktop. Evita a conta na mão e valores incoerentes.
   */
  private ligarCalculoPromocional() {
    const preco = this.produtoPrecoForm.controls['preco'];
    const percentual = this.produtoPrecoForm.controls['percentualDesc'];
    const promocional = this.produtoPrecoForm.controls['precoPromocao'];

    percentual.valueChanges.subscribe(() => this.comGuarda(() => {
      const base = Number(preco.value) || 0;
      const perc = Number(percentual.value) || 0;
      promocional.setValue(this.arredondar(base - (base * perc / 100)), { emitEvent: false });
    }));

    promocional.valueChanges.subscribe(() => this.comGuarda(() => {
      const base = Number(preco.value) || 0;
      const promo = Number(promocional.value) || 0;
      percentual.setValue(base > 0 ? this.arredondar(((base - promo) / base) * 100, 5) : 0, { emitEvent: false });
    }));

    preco.valueChanges.subscribe(() => this.comGuarda(() => {
      const base = Number(preco.value) || 0;
      const perc = Number(percentual.value) || 0;
      if (perc > 0) {
        promocional.setValue(this.arredondar(base - (base * perc / 100)), { emitEvent: false });
      }
    }));
  }

  private comGuarda(acao: () => void) {
    if (this.calculando) {
      return;
    }
    this.calculando = true;
    try {
      acao();
    } finally {
      this.calculando = false;
    }
  }

  private arredondar(valor: number, casas = 2): number {
    const fator = Math.pow(10, casas);
    return Math.round((valor + Number.EPSILON) * fator) / fator;
  }

  /** Limpa a promoção (desconto, valor e validade) de uma vez. */
  limparPromocao() {
    this.comGuarda(() => {
      this.produtoPrecoForm.patchValue(
        { percentualDesc: 0, precoPromocao: 0, validadePromocao: null }, { emitEvent: false });
    });
  }

  /** Tabela base: o preço alterado aqui se propaga às tabelas seguintes com fator/índice. */
  get isTabelaBase(): boolean {
    const v = this.produtoPrecoForm?.value;
    return Number(v?.tabelaId ?? v?.tabela?.id?.tabelaId) === 1;
  }

  buildProdutoPrecoForm(preco: Preco) {
    this.produtoPrecoForm = this.fb.group({
      produtoId: [preco?.produtoId],
      listaId: [preco?.listaId],
      tabelaId: [preco?.tabelaId],
      preco: [preco.preco],
      precoPromocao: [preco.precoPromocao],
      validadePromocao: [preco.validadePromocao],
      saldo: [preco.saldo],
      tabelaDesc: [preco.tabelaDesc],
      listaDesc: [preco.listaDesc],
      percentualAcrescimo: [preco.percentualAcrescimo],
      percentualDesc: [preco.percentualDesc],
      observacao: [preco.observacao],
      listaPreco: [preco.listaPreco],
      tabela: [preco.tabela],
      produtoUuid: [],
    })

  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  submit() {
    if (this.produtoPrecoForm.valid) {
      console.log('form submitted');
      this.save();
    } else {
      this.validateAllFormFields(this.produtoPrecoForm); // {7}
    }
  }

  save(){
    // this.produtoPrecoForm.patchValue({ preco: this.produtoPrecoForm['preco'] });
    // this.produtoPrecoForm.patchValue({ percentualDesc: this.produtoPrecoForm['percentualDesc'] });
    // this.produtoPrecoForm.patchValue({ precoPromocao: this.produtoPrecoForm['precoPromocao'] });
    // this.produtoPrecoForm.patchValue({ validadePromocao: this.produtoPrecoForm['validadePromocao']?.toISOString()?.slice(0, 19) });
    // this.produtoPrecoForm.patchValue({ observacao: this.produtoPrecoForm['observacao'] });
   
    const valor = this.produtoPrecoForm.value;
    if (Number(valor?.percentualDesc) > 0 && !valor?.validadePromocao) {
      this.aviso('Informe a validade da promoção: sem data o desconto não é aplicado.', true);
      return;
    }

    this.precos = [];
    this.precos.push(valor);

    // 1) Grava o preço editado (com todos os campos: promoção/desconto/observação).
    this.salvando = true;
    this.produtoService.saveOrUpdatePrecos(this.precos).subscribe(
      (precos) => {
        const v = this.produtoPrecoForm.value;
        const tabelaId = v.tabelaId ?? v.tabela?.id?.tabelaId;
        const listaId = v.listaId ?? v.listaPreco?.id;

        // 2) Cascata: ao alterar a TABELA BASE (tabela 1), propaga o preço para as tabelas
        // SEGUINTES com fator+índice (mesma regra do desktop), via POST /produto/preco/copia-tabela
        // (backend copiarComFatores: base + cascata + completude das tabelas com fator/índice).
        if (Number(tabelaId) === 1) {
          const item: CopiaPrecoItem = {
            produtoId: v.produtoId,
            precoBase: Number(v.preco),
            listaId: listaId,
            tabelaId: tabelaId,
          };
          this.produtoService.copiaTabelaPreco([item]).subscribe(
            () => {
              this.salvando = false;
              this.aviso('Preço atualizado e propagado às tabelas seguintes (fator/índice).');
              this.dialogRef.close(true);
            },
            (err) => {
              this.salvando = false;
              this.aviso('Preço salvo, mas não foi possível propagar às tabelas seguintes.', true);
              this.dialogRef.close(true);
            }
          );
        } else {
          this.salvando = false;
          this.aviso('Preço atualizado.');
          this.dialogRef.close(true);
        }
      },
      (err) => {
        this.salvando = false;
        this.aviso('Não foi possível atualizar o preço.', true);
      });

  }

  private aviso(mensagem: string, erro = false) {
    this.snack.open(mensagem, 'OK', { duration: erro ? 6000 : 3000 });
  }

  close() {
    this.dialogRef.close();
  }

}
